import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
const icon = `<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 5.5 8 11l5.5-5.5"></path>`;
export class IconChevronDown16 extends LitElement {
  get attrs() {
    const attrs = { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', fill: 'none', viewBox: '0 0 16 16' };
    Array.from(this.attributes).forEach(({ nodeName, nodeValue }) => attrs[nodeName] = nodeValue);
    return Object.entries(attrs).map(([k, v]) => `${k}="${v}"`).join(' ');
  }
  render() { return html`${unsafeHTML(`<svg ${this.attrs}>${icon}</svg>`)}`; }
}
if (!customElements.get('f-icon-chevron-down16', IconChevronDown16)) {
  customElements.define('f-icon-chevron-down16', IconChevronDown16);
}